import moment from 'moment';
import { calcNewRoomDistributionAngle } from '@/functions/d3_geometry/d3Functions-demo.js';

export default {
	// Room creation, updation, invitation, and deletion
	createRoom({rootGetters, dispatch}, [topic, joinLink, lifestyle, conferenceType, color, imageUrl, textColor, hideName, angle]) {
		// only admins can create fixed rooms
		return dispatch('request', {
			url: `/space/${rootGetters.getCurrentAreaId}`,
			method: 'post',
			params: { lifestyle },
			data: {
				startTime: moment().format(),
				endTime: moment().add(2, 'hours').format(),
				hostEmail: rootGetters['current_user/email'],
				baseAngle: angle > -1 ? angle : calcNewRoomDistributionAngle(),
				topic,
				joinLink,
				conferenceType,
				color,
				imageUrl,
				textColor,
				hideName
			}
		})
	},
	createSpacePortal({rootGetters, dispatch}, [areaId, data]) {
		// only admins can create a portal to another space (area)
		return dispatch('request', {
			url: `/space/${areaId}/portal`,
			method: 'post',
			data: {
				...data,
				startTime: moment().format(),
				endTime: moment().add(2, 'hours').format(),
				hostEmail: rootGetters['current_user/email'],
				baseAngle: data.baseAngle > -1 ? data.baseAngle : calcNewRoomDistributionAngle(),
			}
		});
	},
	updateRoom({dispatch}, [id, data]) {
		// only admins can update fixed rooms
		// only the creator of the room can update temporary rooms (this should be changed to allow admins)
		return dispatch('request', {
			url: `/space/${id}`,
			method: 'put',
			data
		});
	},
	getRoom({dispatch}, id) {
		// pull room data again
		return dispatch('request', {
			url: `/space/${id}`,
			method: 'get'
		});
	},
	adminDeleteRoom({dispatch}, id){
		// only for fixed rooms - temporary rooms delete themselves when everybody leaves
		// also, "deleting" a fixed room actually just converts it to a temporary room
		return dispatch('request', {
			url: '/area-management/space/',
			method: 'DELETE',
			params: {spaceId: id}
		});
	},

	roomInvite({dispatch}, [guestId, roomId]) {
		return dispatch('request', {
			url: `/space/invite/${roomId}`,
			method: 'post',
			params: { guestId }
		})
	},
	cancelRoomInvite({dispatch}, notification) {
		return dispatch('request', {
			url: `/space/invite/cancel`,
			method: 'put',
			data: {
				spaceId: notification.hostLocationId,
				notificationId: notification.id,
				message: "Cancelled"
			}
		})
	},
	respondRoomInvite({dispatch}, [notification, message, response]) {
		return dispatch('request', {
			url: `/space/invite/respond`,
			method: 'put',
			data: {
				spaceId: notification.hostLocationId,
				notificationId: notification.id,
				message, response
			}
		})
	},
	// guest room managment
	addRoomPassword({dispatch}, [roomId, value]) {
		return dispatch('request', {
			url: `/space/${roomId}/password`,
			method: 'post',
			data: {
				password: value
			}
		})
	},
	removeRoomPassword({dispatch}, roomId) {
		return dispatch('request', {
			url: `/space/${roomId}/password`,
			method: 'delete'
		})
	},
	toggleRoomLobby({dispatch}, [roomId, value]) {
		return dispatch('request', {
			url: `/space/${roomId}/lobby`,
			method: 'put',
			data: {
				lobbyEnabled: value
			}
		})
	},
	kickFromRoom({dispatch}, [roomId, userId]) {
		return dispatch('request', {
			url: `/space/${roomId}/kick-out`,
			method: 'post',
			data: {
				userId
			}
		})
	},
	makeCoHost({dispatch}, [roomId, userId]) {
		return dispatch('request', {
			url: `/space/${roomId}/promote-co-host`,
			method: 'post',
			data: {
				userId
			}
		})
	}
}
